export default class CredentialsLostRecordEvents {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  /** RC admin only: one page of lost-password requests. */
  list(filter) {
    const event = CredentialsLostRecordEvents.List.Request(filter);
    return this.eventsDomain.initRequest(event);
  }

  static List = {
    Names: {
      Request: 'CredentialsLostRecordListRequestEvent',
      Response: 'CredentialsLostRecordListResponseEvent',
    },

    Request: function (filter) {
      return {
        handler: "CredentialsLostRecordListRequestEvent",
        eventName: "CredentialsLostRecordListRequestEvent",
        filter: filter.data,
      };
    },
  }
}
